import { TableCell, TableRow } from '@mui/material';
import {
  MAIN_LIGHT_COLOR,
  SECOND_LIGHT_GRAY,
  MAIN_COLOR,
} from '../../themes/colors';
import { TABLE_CELL } from '../../themes/fonts';
import { makeStyles } from '@mui/styles';
import InfoIcon from '@mui/icons-material/Info';
import { IQuestionnaire } from '../../libs/apis/questionnaires/types';
import { IArea } from '../../redux/areas/types';
import { translate } from '../../libs/utils';

interface Props {
  data: IQuestionnaire[];
  onClickDetail: (id: number) => void;
}

const useStyles = makeStyles({
  icon: {
    color: MAIN_COLOR,
    '&:hover': {
      color: MAIN_LIGHT_COLOR,
      cursor: 'pointer',
    },
  },
});

const TableBody = ({ data, onClickDetail }: Props) => {
  const classes = useStyles();

  const handleRenderTargetArea = (targetArea: IArea[]) => {
    const areaNames = targetArea.map((area: IArea) => area.area_name);
    return areaNames.join(', ');
  };

  return (
    <>
      {data?.map((row, rowIndex) => (
        <TableRow key={rowIndex}>
          <TableCell
            align="center"
            key="title"
            sx={{
              color: SECOND_LIGHT_GRAY,
              fontSize: TABLE_CELL,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '183px',
              width: '183px',
              whiteSpace: 'nowrap',
              textAlign: 'center',
            }}
          >
            {row.title}
          </TableCell>
          <TableCell
            align="center"
            key="target_area"
            sx={{
              color: SECOND_LIGHT_GRAY,
              fontSize: TABLE_CELL,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '351px',
              width: '351px',
              whiteSpace: 'nowrap',
            }}
          >
            {handleRenderTargetArea(row.target_area as IArea[])}
          </TableCell>
          <TableCell
            align="center"
            key="detail"
            sx={{
              color: SECOND_LIGHT_GRAY,
              fontSize: TABLE_CELL,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '392px',
              width: '392px',
              whiteSpace: 'nowrap',
            }}
          >
            {row.detail}
          </TableCell>
          <TableCell
            align="center"
            key="user_type"
            sx={{
              color: SECOND_LIGHT_GRAY,
              fontSize: TABLE_CELL,
              maxWidth: '227px',
              width: '227px',
            }}
          >
            {row.isOpen
              ? translate('questionnaire.list.table.status.open')
              : translate('questionnaire.list.table.status.close')}
          </TableCell>
          <TableCell
            align="center"
            key="edit_action"
            sx={{ color: SECOND_LIGHT_GRAY, fontSize: TABLE_CELL }}
          >
            <InfoIcon
              className={classes.icon}
              onClick={() => onClickDetail(row?.questionnaire_id ?? 0)}
            />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
export default TableBody;
